export default function excalidrawDrawingJsonObject() {
  return {
    elements: [],
    files: {},
  };
}
